module.exports = __webpack_public_path__ + "static/terms-1b6600fcd4fdb20deee1f13eab22cc8e.pdf";